<template>
	<v-card :elevation="1" class="flex round-card background-2 d-flex flex-column">
        <v-card-title class="pa-3" style="white-space: nowrap">
			<p class="pl-2 pl-xl-3">Calendario</p>
            
            <!-- Badge eventi quando collassato -->
            <v-badge 
                v-if="!expand && todayEvents.length > 0"
                :content="todayEvents.length"
                color="primary"
                class="ml-2"
            >
                <span class="caption text--secondary">(Eventi oggi)</span>
            </v-badge>
            
            <v-spacer></v-spacer>        
            
            <!-- Pulsante oggi (visibile solo quando espanso) -->
            <v-btn 
                v-if="expand"
                class="mx-1" 
                text 
                small
                @click="goToToday"
            >
                Oggi
            </v-btn>
            
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="mx-1" text icon @click="$router.push('calendar')">
                        <v-icon class="fs20i">mdi-calendar</v-icon>
                    </v-btn>
                </template>
                <span>Vai al calendario completo</span>
            </v-tooltip>     
            
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                        <v-icon>{{ expand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </template>                    
                <span>{{ expand ? 'Comprimi' : 'Espandi' }}</span>
            </v-tooltip>
        </v-card-title>            
        
        <v-divider v-if="expand"></v-divider>

        <v-expand-transition>
            <div v-show="expand" class="unified-scroll-container" style="height: 450px; overflow-y: auto; overflow-x: hidden;">
                
                <!-- Skeleton loader durante caricamento -->
                <v-fade-transition>
                    <v-skeleton-loader
                        v-if="loading"
                        type="date-picker"
                        class="mx-auto skeleton-fade"
                    ></v-skeleton-loader>
                </v-fade-transition>

                <!-- Contenuto principale -->
                <v-fade-transition>
                    <div v-if="!loading" class="content-fade">

                        <!-- Calendario -->
                        <div class="calendar-section">
                        <gmh-date-picker
                            inline
                            v-model="date"
                            @update:picker-date="changeMonth($event)"
                            :picker-props="{
                                events: functionEvents,
                                'event-color': getEventColor,
                                'no-title': true,
                                reactive: true,
                                'full-width': true,
                                'show-week': true,
                                class: 'elevation-0'
                            }"
                        ></gmh-date-picker>
                    </div>

                    <!-- Sezione Eventi -->
                    <div class="events-section">
                        
                        <!-- Header eventi con conteggio -->
                        <div v-if="currentEvents.length > 0" class="px-4 py-2 background-1">
                            <span class="subtitle-2 font-weight-medium">
                                {{ currentEvents.length }} {{ currentEvents.length === 1 ? 'evento' : 'eventi' }} per <span style="text-transform: capitalize;">{{ formatDateHeader }}</span>
                            </span>
                        </div>

                        <!-- Lista eventi -->
                        <div v-if="currentEvents.length > 0" class="background-2 mb-4">
                            <template v-for="(item, index) in groupedEvents">
                                <!-- Separatore fascia oraria -->
                                <div v-if="item.isHeader" :key="'header-' + index" class="px-3 py-1 background-1" style="min-height: 22px;">
                                    <span class="caption font-weight-medium text--secondary">
                                        {{ item.title }}
                                    </span>
                                </div>
                                
                                <!-- Evento -->
                                <v-list-item 
                                    v-else
                                    :key="'event-' + index"
                                    dense 
                                    two-line
                                    class="event-item py-1"
                                    style="min-height: 44px; max-height: 44px;"
                                    @click="navigateToEvent(item.event)"
                                    @click.middle="navigateToEvent(item.event)"
                                    ripple
                                >
                                    <v-list-item-avatar size="28">
                                        <v-icon :color="item.event.calendar ? item.event.calendar.color : 'primary'">
                                            {{ getEventableIcon(item.event.eventable_type) }}
                                        </v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title class="text-truncate">
                                            {{ item.event.name }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                                            {{ formatEventDate(item.event) }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    
                                    <v-list-item-action>
                                        <v-chip 
                                            x-small 
                                            :color="item.event.calendar ? item.event.calendar.color : 'grey'"
                                            text-color="white"
                                        >
                                            {{ item.event.calendar ? item.event.calendar.name : 'Generale' }}
                                        </v-chip>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </div>

                        <!-- Messaggio nessun evento -->
                        <div v-else class="d-flex flex-column align-center justify-center pa-4" style="min-height: 120px;">
                            <v-icon large color="grey lighten-1" class="mb-2">
                                mdi-calendar-blank
                            </v-icon>
                            <p class="text-center grey--text text--lighten-1 mb-0">
                                Nessun evento per<br>
                                <span class="capitalize font-weight-medium">{{ formatCurrentDate }}</span>
                            </p>
                        </div>
                    </div>
                    </div>
                </v-fade-transition>

            </div>
        </v-expand-transition>

    </v-card>  
</template>

<script>

	import CalendarMixin from '@/mixins/CalendarMixin'

    export default {
        name: 'my-events',
		mixins: [CalendarMixin],
        data() {
            return {
                events: [],
                expand: localStorage.getItem('my_events_'+this.$store.getters.getProfile.id) === 'true' || localStorage.getItem('my_events_'+this.$store.getters.getProfile.id) === null,
                loading: false,
                fieldsset: {},
                filters: {},
                date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                firstTime: true
            }
        },

        computed: {
            eventsDate() {
                return this.events.map((event) => {
                    return event.started_at_date
                })
            },

            currentEvents() {
                return this.events.filter((event) => {
                    return event.started_at_date == this.date
                })                
            },
            
            todayEvents() {
                const today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
                return this.events.filter((event) => {
                    return event.started_at_date == today
                })
            },
            
            groupedEvents() {
                const groups = []
                const timeGroups = {
                    morning: { title: 'Mattina (00:00 - 12:00)', events: [] },
                    afternoon: { title: 'Pomeriggio (12:00 - 18:00)', events: [] },
                    evening: { title: 'Sera (18:00 - 24:00)', events: [] },
                    allday: { title: 'Tutto il giorno', events: [] }
                }
                
                this.currentEvents.forEach(event => {
                    if (event.allday) {
                        timeGroups.allday.events.push(event)
                    } else {
                        const hour = new Date(event.started_at).getHours()
                        if (hour < 12) {
                            timeGroups.morning.events.push(event)
                        } else if (hour < 18) {
                            timeGroups.afternoon.events.push(event)
                        } else {
                            timeGroups.evening.events.push(event)
                        }
                    }
                })
                
                // Aggiungi solo i gruppi con eventi
                Object.values(timeGroups).forEach(group => {
                    if (group.events.length > 0) {
                        groups.push({ isHeader: true, title: group.title })
                        group.events.forEach(event => {
                            groups.push({ isHeader: false, event })
                        })
                    }
                })
                
                return groups
            },
            
            currentMonthYear() {
                return moment(this.date).format('MMMM YYYY').replace(/^\w/, c => c.toUpperCase())
            },
            
            formatDateHeader() {
                const selectedDate = moment(this.date)
                const today = moment()
                
                if (selectedDate.isSame(today, 'day')) {
                    return 'oggi'
                } else if (selectedDate.isSame(today.add(1, 'day'), 'day')) {
                    return 'domani'
                } else if (selectedDate.isSame(today.subtract(2, 'day'), 'day')) {
                    return 'ieri'
                } else {
                    return selectedDate.format('D MMMM')
                }
            },
            
            formatDay(event) {
                return (event) => {
                    return moment(event.started_at).format("D")
                }
            },
            
            formatCurrentDate() {
                return moment(this.date).format("D MMMM")
            },

        },

        watch: {
            expand: {
                handler(newValue) {
                    if(newValue === true) {                        
                        this.getData()
                        localStorage.setItem('my_events_'+this.$store.getters.getProfile.id, 'true')
                    } else {
                        localStorage.setItem('my_events_'+this.$store.getters.getProfile.id, 'false')
                    }
                },
                immediate: true
            },

            date: {
                handler(newValue, oldValue) {
                    this.getData()
                },
            }
        },    

        methods: {
            functionEvents (date) {
                return this.events.map((event) => {
                    if(event.started_at_date == date) {
                        return event.calendar.color
                    }
                    return false
                })
            },
            
            getEventColor(date) {
                const event = this.events.find(e => e.started_at_date === date)
                return event && event.calendar ? event.calendar.color : 'primary'
            },

            changeMonth(event) {
                if(!this.firstTime) {
                    let newDate = moment(event + this.date.substring(7,10))
                    if(newDate.isValid()) {
                        this.date = newDate.format('YYYY-MM-DD')
                    } else {
                        this.date = event + '-01'
                    }
                }
                this.firstTime = false
            },
            
            previousMonth() {
                this.date = moment(this.date).subtract(1, 'month').format('YYYY-MM-DD')
            },
            
            nextMonth() {
                this.date = moment(this.date).add(1, 'month').format('YYYY-MM-DD')
            },
            
            goToToday() {
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            },

            getData() {
                this.loading = true
                let from = moment(this.date).startOf('month').format('YYYY-MM-DD HH:mm')
                let to = moment(this.date).endOf('month').format('YYYY-MM-DD HH:mm')            
                this.axios.post('myevents', {from, to}).then(response => {
                    // get body data
                    this.events = response.data.data
                    this.loading = false

                    this.$store.commit('endProgress')
                    this.loaded = true

                }, response => {
                    // error callback
                    this.loading = false
                })
            },

            navigateToEvent(event) {
                // Usa il metodo del mixin per ottenere la route
                const route = this.getEventRoute(event)
                
                // Apri in una nuova scheda
                const fullUrl = `${window.location.origin}/#${route}`
                window.open(fullUrl, '_blank')
            },

        },
        
        mounted() {
            // Auto-espandi se ci sono eventi oggi
            if (!this.expand && this.todayEvents.length > 0) {
                this.expand = true
            }
        }
    }
</script>

<style scoped>
    /* Capitalize del mese nel date picker */
    ::v-deep .v-date-picker-header__value button {
        text-transform: capitalize !important;
    }
    
    /* Transizioni soft per skeleton e contenuto */
    .skeleton-fade {
        animation: softFadeIn 0.2s ease-in-out;
    }
    
    .content-fade {
        animation: softFadeIn 0.1s ease-in-out;
    }
    
    @keyframes softFadeIn {
        from {
            opacity: 0;
            transform: translateY(4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>